import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Alert, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../components/Tabella/ChipFilter';
import { elencoPagineParlanti, etichettaStato, PAGINE_PARLANTI_SIMULAZIONE } from '../../../../api-client/pagineParlanti';
import { nomePagina } from './scheda';

/*
 * Pagine parlanti: per ogni pagina della Struttura il testo della colonna destra. La riga apre la scheda
 * (scheda.js), dove si scrivono titolo e testo e si pubblica. Una pagina parlante per indirizzo.
 */

export const LIST_URL = '/superadmin/pagine-parlanti';
const STATO_OPTIONS = ['Pubblicata', 'Bozza'];

const dataBreve = (iso) => (iso ? new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');

export const ListaPagineParlanti = () => {
    const navigate = useNavigate();
    const [righe, setRighe] = useState(null);
    const [errore, setErrore] = useState('');
    const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

    const carica = useCallback(async () => {
        const r = await elencoPagineParlanti();
        if (!r || r.error) {
            setErrore(r?.error || 'Impossibile leggere le pagine parlanti.');
            setRighe([]);
            return;
        }
        setRighe(r.map((p) => ({ ...p, pagina: nomePagina(p.url), stato: etichettaStato(p.status), aggiornata: p.updatedAt || '' })));
    }, []);

    useEffect(() => { carica(); }, [carica]);

    const filtrate = useMemo(() => righe && righe.filter((r) => filtroMultiplo(statoFilter, STATO_OPTIONS, r.stato)), [righe, statoFilter]);

    const data_column = [
        {
            Header: 'Aggiornata',
            Footer: 'Aggiornata',
            accessor: 'aggiornata',
            compact: true,
            disableGlobalFilter: true,
            Cell: ({ value }) => dataBreve(value),
        },
        { Header: 'Titolo', Footer: 'Titolo', accessor: 'title', larghezza: '30%' },
        {
            Header: 'Pagina',
            Footer: 'Pagina',
            accessor: 'pagina',
            Cell: ({ row }) => (
                <div>
                    {row.original.pagina}
                    <small className="d-block text-muted">/{row.original.url}</small>
                </div>
            ),
        },
        // Lo stato è sempre l'ultima colonna, prima della freccia (regola SUI)
        {
            Header: 'Stato',
            Footer: 'Stato',
            accessor: 'stato',
            disableGlobalFilter: true,
            Cell: ({ row }) => (
                <div className="d-flex align-items-center">
                    <i className={`fa fa-circle me-1 ${row.original.status === 'PUBLISHED' ? 'text-success' : 'text-warning'}`}></i>
                    <div>{row.original.stato}</div>
                </div>
            ),
        },
    ];

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            {PAGINE_PARLANTI_SIMULAZIONE && (
                <Alert variant="warning" className="text-dark">
                    <strong>Simulazione:</strong> finché il backend non è pronto le pagine parlanti restano in questo browser.
                    Per vederle come una struttura, entra con un account struttura in questo stesso browser.
                </Alert>
            )}
            <TabellaLista
                openColumn={'title'}
                openRow={(row) => navigate(`${LIST_URL}/${row.id}`)}
                cardTitle={'Pagine parlanti'}
                pageList={true}
                hasSearch={true}
                searchPlaceholder={'Cerca per titolo o pagina'}
                hasFilter={false}
                filterControl={
                    <div className="sid-chip-filters">
                        <ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
                    </div>
                }
                hasAddMore={true}
                linkAddMore={`${LIST_URL}/nuova`}
                labelAddMore={'Nuova pagina parlante'}
                data_column={data_column}
                data_json={filtrate}
                sort_by={'aggiornata'}
                sort_type={'desc'}
            />
        </>
    );
};

export default ListaPagineParlanti;
